import React, { useEffect } from 'react';
import { useTranslation, Metrics } from 'src/utils';
import DiscussionCategory from 'src/components/homepage/DiscussionCategory';
import Tools from 'src/components/homepage/Tools';
import RecentDiscussion from 'src/components/homepage/RecentDiscussions';
import { MethodName, Pages } from 'src/constants/metrics';
import HomepageData from 'src/server/components/homepage/server-side-props';
import { Helmet } from 'react-helmet-async';

export const getServerSideProps = HomepageData;

const Home = () => {
  useEffect(() => {
    const pageMetrics = new Metrics(MethodName.pageLoad);
    pageMetrics.publishPageLoad(Pages.home);
  }, []);
  const { t } = useTranslation();

  return (
    <div data-testid="home-page" className="mb-4 flex flex-col justify-center">
      <Helmet>
        <title>{t('page_title_home')}</title>
        <meta name="description" content={t('page_description_home')} />
      </Helmet>
      <h1 className="mt-3.5 !mb-0 text-center text-2xl font-normal">
        {t('homePage_header')}
      </h1>
      <DiscussionCategory />
      <RecentDiscussion />
      <Tools />
    </div>
  );
};

export default Home;
